<template>
  <div>
    <router-view> </router-view>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { getSearchPermission } from '@/utils/api/permission-verification.js'
export default {
  computed: {
    ...mapState('permissionVerification', ['accessData']),
  },
  methods: {
    ...mapMutations('permissionVerification', ['SET_ACCESS_DATA']),

    ...mapActions('permissionVerification', ['requestAccessData']),

    // 是否要放行
    getRelease() {
      if (this.accessData?.accessPermission === 1) {
        // 此时代表客户已经符合放行条件, 直接放行
        if(this.$route.query.to){
          this.$router.push({
            name: this.$route.query.to || 'dashboard' ,
          })
        }
      }
    },
  },
  async created() {
    // 判断 如果会员信息为空, 重新请求
    if (!this.accessData) {
      await this.requestAccessData()
      this.getRelease()
    } else {
      // 如果有, 则直接检测是否放行
      this.getRelease()
    }
  },
}
</script>

<style lang="scss" scoped></style>
